<action class="lp-wishlist-toggle flex flex-middle flex-justify-center cursor-pointer"
        [status]="status"
        (click)="toggle()"
        [attr.aria-label]="inWishlist ? 'Remove from Wishlist' : 'Add to Wishlist'"
        cy-wishlistAddBtn>
    <i class="flex fs-3 col-43"
       [ngClass]="{'icon-wishlist-fill': inWishlist && !inWishlistView, 'icon-wishlist' : !inWishlist && !inWishlistView, 'icon-close' : inWishlist && inWishlistView }"
       aria-hidden="true"></i>
</action>
